import { render } from "./dropdownbutton.vue?vue&type=template&id=ffb24e56"
import script from "./dropdownbutton.vue?vue&type=script&lang=js"
export * from "./dropdownbutton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__